/**
 * Builds a "when" block structure for a geofence trigger in MeshBot.
 *
 * @param {string} itemId - The ID of the item associated with the geofence (typically a device or resource ID).
 * @param {string} locationUuid - The UUID of the specific geofence location.
 * @param {string} operation - The operation to perform (e.g., 'added', 'removed').
 * @returns {Object} A block object containing type, options, and fields for the geofence trigger.
 *
 * @example
 * const block = buildWhenGeofenceBlock('item123', 'location-uuid-456', 'added');
 * // block = {
 * //   blockType: 'when',
 * //   blockOptions: {
 * //     method: {
 * //       name: 'isDictionaryChanged',
 * //       args: { item: 'item', key: 'key', operation: 'operation' }
 * //     }
 * //   },
 * //   fields: [
 * //     { name: 'item', type: 'item', value: 'item123' },
 * //     { name: 'key', type: 'token', value: 'location-uuid-456' },
 * //     { name: 'operation', type: 'token', value: 'added' }
 * //   ]
 * // }
 */
export const buildWhenGeofenceBlock = (itemId, locationUuid, operation) => {
    return {
        blockType: 'when',
        blockOptions: {
            method: {
                name: 'isDictionaryChanged',
                args: {
                    item: 'item',
                    key: 'key',
                    operation: 'operation',
                },
            },
        },
        fields: [
            {
                name: 'item',
                type: 'item',
                value: itemId,
            },
            {
                name: 'key',
                type: 'token',
                value: locationUuid,
            },
            {
                name: 'operation',
                type: 'token',
                value: operation,
            },
        ],
    };
};
